<template>
  <div class="comment-list">
    <template v-if="commentCount && videoType !== 'shrink'">
      <div class="page-header">
        <div class="S8 T1 font-bold">
          {{ '评论 (' + commentsInfo.commentsCount + ')' }}
        </div>
      </div>
      <div class="item-line L2"></div>
    </template>

    <div class="nodata-container" v-if="comments.length == 0">
      <img src="../../static/bg_comments.png" alt="" />
      <div class="S6 T3">暂无评论</div>
    </div>
    <template v-else>
      <div v-for="item in comments" :key="item.id" class="list-container">
        <component
          :is="getComponent"
          :item="item"
          :showReplyCount="true"
          @onReplyEvent="onReplyEvent(item)"
          @onDeleteEvent="onDeleteEvent(item)"
          @onShowAllEvent="onShowAllEvent"
        ></component>
      </div>
    </template>

    <comment-input-popup
      :commentsInfo="commentsInfo"
      :hasPermission="hasPermission"
      :id="id"
      v-if="showPopup"
      :showPopup="showPopup"
      :isFavored="isFavored"
      @onCommitEvent="onCommitEvent"
    ></comment-input-popup>
  </div>
</template>

<script>
import CommentItem from './components/CommentItem'
import ShrinkCommentItem from './components/ShrinkCommentItem'
import CommentInput from './components/CommentInput'
import CommentInputPopup from './components/CommentInputPopup'

import store from '@/store'
import { mapActions } from 'vuex'

export default {
  name: 'Comments',
  props: {
    commentsInfo: {
      type: Object,
      default: null
    },

    hasPermission: {
      type: Boolean,
      default: false
    },

    // 控制显示收藏icon和传入收藏接口的参数
    id: {
      type: String,
      default: ''
    },
    isFavored: {
      type: Boolean,
      default: false
    },
    commentCount: {
      type: Boolean,
      default: true
    },
    videoType: {
      type: String,
      default: ''
    },
    showPupInput: {
      type: Boolean
    }
  },
  components: {
    CommentItem,
    CommentInput,
    ShrinkCommentItem,
    CommentInputPopup
  },
  data() {
    return {
      showAd: true,
      comments: [],
      showPopup: false
    }
  },

  mounted() {
    this.showPopup = this.showPupInput && this.hasPermission
  },
   computed: {
    getComponent() {
      let componentName = ''
      switch (this.videoType) {
        case 'shrink':
          componentName = 'ShrinkCommentItem'
          break
        default:
          componentName = 'CommentItem'
          break
      }
      return componentName
    }
  },

  watch: {
    'commentsInfo.topicId': {
      handler: function(val) {
        if (val > 0) {
          this.getCommentLists()
        }
      },
      deep: true,
      immediate: true
    },
    showPupInput() {
      this.showPopup = this.showPupInput && this.hasPermission
    },
    hasPermission(newValue, oldValue) {
      console.log('====comments hasPermission', newValue, oldValue)
      this.showPopup = this.showPupInput && this.hasPermission
    }
  },
  methods: {
    ...mapActions('comment', [
      'getComments',
      'commitComment',
      'deleteComment',
      'getCommentList'
    ]),

    onReplyEvent(item) {
      this.$emit('onReplyEvent', item)
    },
    onShowAllEvent(val) {
      this.$emit('onShowAllEvent', val)
    },
    onCommitEvent(content) {
      this.commitCommentFunc(content)
    },

    onDeleteEvent(item) {
      this.deleteComments(item.id)
    },

    async getCommentLists() {
      const params = {
        topicId: this.commentsInfo?.topicId,
        direction: 2,
        orderBy: 0,
        'Ykt-ViewState': ''
      }

      try {
        const res =
          this.videoType === 'shrink'
            ? await this.getCommentList(params)
            : await this.getComments(params)
        if (res) {
          this.comments = res.detail?.list
          this.$nextTick(() => this.$emit('updateSwiper'))
        }
      } catch (err) {
        console.log('=====request data error', err)
      }
    },
    async commitCommentFunc(content) {
      const params = {
        topicId: this.commentsInfo?.topicId,
        parentCommentId: null,
        content: content
      }

      try {
        this.$loading('提交中...')
        const res = await this.commitComment(params)
        console.log('commitComment111111111111111', res);
        this.$hideLoading()
        if (res.code === 0) {
          this.$toast('发布成功')
          this.getCommentLists()
        } else if (res.code == 403001) {
          this.$toast(res.msg)
          store.commit('comment/setInputType', 4)
        } else if (res.code == 403002) {
          this.$toast(res.msg)
          store.commit('comment/setInputType', 1)
        } else if (res.code == 403003) {
          this.$toast(res.msg)
          store.commit('comment/setInputType', 3)
        } else if (res.code == 403004) {
          this.$toast(res.msg)
          store.commit('comment/setInputType', 2)
        } else {
          this.$toast(res.msg)
        }
      } catch (err) {
        this.$hideLoading()
        console.log('=====request data error', err)
      }
    },
    async deleteComments(commentId) {
      try {
        this.$loading('提交中...')
        const res = await this.deleteComment(commentId)
        this.$hideLoading()
        if (res.code === 0) {
          store.commit('comment/deleteComment', commentId)
          this.$toast('删除成功')
          this.getCommentLists()
        } else {
          this.$toast(res.msg)
        }
      } catch (err) {
        this.$hideLoading()
        console.log('=====request data error', err)
      }
    }
  }
}
</script>

<style scoped>
.page-header {
  height: 120px;
  padding-left: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.input-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column-reverse;
  z-index: 199999;
}

.nodata-container {
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.nodata-container img {
  width: 400px;
  height: 224px;
}
.comment-list{
  padding-bottom: 190px;
}
</style>
